




















import Vue from 'vue'
import { Currency } from '@/Domain/Batch/Currency'

export default Vue.extend({
  name: 'BatchTableRow',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    readableTaxes (): string {
      if (!this.item.taxes) {
        return '-'
      }
      const currency = new Currency(this.item.taxes)
      return currency.pointToString()
    }
  },
  methods: {
    normalizeQuantity (quantity: number): string {
      return quantity.toLocaleString('es-ES')
    },
    onButtonClicked (): void {
      this.expanded = !this.expanded
      this.$emit('batchrow-expand-toggled', this.expanded)
    },
    yesNoNullContent (content: boolean | null): string {
      if (content === null) {
        return '-'
      }
      const translatedContent = content === true
        ? this.$t('shared.si')
        : this.$t('shared.non')
      return translatedContent.toString()
    },
    onCheck (checked: boolean): void {
      this.$emit('batchSelecteds', checked)
    }
  }
})
